// Group landing-page template registry. Groups get their OWN premium templates
// (community/join focused) — distinct from the course templates. Add new group
// templates here as they are built.
import Template1 from "./Template1";
import Template2 from "./Template2";
import Template3 from "./Template3";
import Template4 from "./Template4";
import Template5 from "./Template5";

const GROUP_TEMPLATES = { 1: Template1, 2: Template2, 3: Template3, 4: Template4, 5: Template5 };

export function pickGroupTemplate(id) {
    return GROUP_TEMPLATES[Number(id)] || Template1;
}

export default GROUP_TEMPLATES;
